import { SyncState, VisitOutcome } from '@axle-health/graphql-schema';

import { TELADOC_CONTAINER_KEYS } from '../containerKeys';
import { QueueDefinition, RootEntity } from '../types';

/**
 * Teladoc runs virtual visits, so its dashboard is narrow: who needs a clinician,
 * and what failed to reach the external calendar.
 *
 * Every queue is declared in full here, including the ones whose filters happen to
 * match another org's. A queue is per-org configuration, so changing what this org
 * counts means editing this file and no other.
 */

// Visits still waiting on a clinician.
const UNASSIGNED: QueueDefinition<RootEntity.VISIT> = {
    key: TELADOC_CONTAINER_KEYS.unassigned,
    label: 'Unassigned',
    rootEntity: RootEntity.VISIT,
    snoozable: false,
    heavyQuery: false,
    buildFilters: () => ({
        needsClinicians: { exact: true },
        outcome: { exact: VisitOutcome.NONE },
    }),
};

// Shift blocks that failed to reach the external calendar.
const SHIFT_BLOCK_SYNC_ISSUES: QueueDefinition<RootEntity.SHIFT_BLOCK> = {
    key: TELADOC_CONTAINER_KEYS.shiftBlockSyncIssues,
    label: 'Shift Block Sync Issues',
    rootEntity: RootEntity.SHIFT_BLOCK,
    snoozable: false,
    heavyQuery: true,
    buildFilters: () => ({
        syncStatus: { state: { exact: SyncState.FAILING } },
    }),
};

export const TELADOC_QUEUES: QueueDefinition[] = [UNASSIGNED, SHIFT_BLOCK_SYNC_ISSUES];
